import { axiosClient } from '../../axiosClient';
import type { AccountMetric } from '../types';

type Params = {
  agentId: number;
  metrics: AccountMetric[];
};

export const updateAgentMetrics = ({ agentId, metrics }: Params) =>
  axiosClient.put<AccountMetric[]>(`/dashboard-metric/${agentId}`, metrics);
